import React from 'react';

interface LomavisH1Props {
  /** The text to display inside the H1 heading */
  title: string | number;
  /** Optional additional CSS class names */
  className?: string;
}

/**
 * Atom: LomavisH1
 *
 * A large, prominent page heading.
 * Used for top-level page titles and screen headlines.
 */
export const LomavisH1: React.FC<LomavisH1Props> = ({
  title,
  className = ''
}) => {
  return <h1 className={`fw-bolder fs-1 ${className}`.trim()}>{title}</h1>;
};
